(function () {
  class PowerBarDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('sidewinder:PowerBarAdjustEventDead', this.onPowerBarAdjustDead.bind(this));
      messageBus.subscribe('stake:stakeChanged', this.onStakeChanged.bind(this));
      messageBus.subscribe('persistence:stakeChanged', this.onPersistenceStakeChanged.bind(this));
      messageBus.subscribe('sidewinder:xtraPowerRedBackground', this.onXtraPowerRedBackground.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));
      messageBus.subscribe('spinner:XtraPowerIntroEvent', this.onXtraPowerIntroEvent.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name + ':powerBarContainer';

      this._barMaxLength = 600;
      this._currentPercent = 0;
      this._minimumDisplayPercent = 100 / 16; // request that bar start 1/16th full
      this._barMask = undefined;
      this._powerBarContainer = undefined;
      this._powerFillContainer = undefined;
      this._powerBarBlue = undefined;
      this._powerBarBlueExtra = undefined;
      this._powerBarRed = undefined;
      this._powerBarRedExtra = undefined;
      this._blueParent = undefined;
      this._redParent = undefined;
      this._skipBarSwitch = false;
    }

    update(delta, time) {}

    onStakeChanged(stake) {}

    onGameConfigEvent() {
      this._powerBarContainer = resourceManager.get(this._jsonPath);
      this._powerFillContainer = resourceManager.get(this._jsonPath + ':powerFillContainer');

      this._powerBarBlue = resourceManager.get(this._jsonPath + ':powerFillContainer:blue:powerBarBlue');
      this._powerBarBlue.gotoAndStop(0);
      this._powerBarBlue.visible = false;
      this._powerBarBlue.blendMode = PIXI.BLEND_MODES.ADD;

      this._powerBarBlueExtra = resourceManager.get(this._jsonPath + ':powerFillContainer:blue:powerBarBlueExtra');
      this._powerBarBlueExtra.gotoAndStop(0);
      this._powerBarBlueExtra.visible = false;
      this._powerBarBlueExtra.blendMode = PIXI.BLEND_MODES.ADD;

      this._powerBarRed = resourceManager.get(this._jsonPath + ':powerFillContainer:red:powerBarRed');
      this._powerBarRed.gotoAndStop(0);
      this._powerBarRed.visible = false;
      this._powerBarRed.blendMode = PIXI.BLEND_MODES.ADD;

      this._powerBarRedExtra = resourceManager.get(this._jsonPath + ':powerFillContainer:red:powerBarRedExtra');
      this._powerBarRedExtra.gotoAndStop(0);
      this._powerBarRedExtra.visible = false;
      this._powerBarRedExtra.blendMode = PIXI.BLEND_MODES.ADD;

      this._blueParent = resourceManager.get(this._jsonPath + ':powerFillContainer:blue');
      this._blueParent.visible = false;

      this._redParent = resourceManager.get(this._jsonPath + ':powerFillContainer:red');
      this._redParent.visible = false;

      this._barMask = resourceManager.get(this._jsonPath + ':powerFillContainer:barMask');
      this._barMask.renderable = false;
      this._powerFillContainer.mask = this._barMask;

      this._powerBarBlue.gotoAndPlay(0);
      this._powerBarBlue.visible = true;

      this._powerBarRed.gotoAndPlay(0);
      this._powerBarRed.visible = true;
    }

    onPowerBarAdjustDead(task) {
      this._currentPercent = task.xPowerBar.finalBarPower;
      this.setFillPercentage(this._currentPercent);
    }

    onXtraPowerTriggerEvent(task) {
      this.onXtraPowerRedBackground({ enabled: true });
    }

    onXtraPowerIntroEvent(task) {
      this._powerBarRedExtra.visible = true;
      this._powerBarRedExtra.gotoAndPlay(0);
    }

    onXtraPowerRedBackground(data) {
      if (!data.enabled && this._redParent.visible) {
        const stakeController = resourceManager.getController('stakeController');
        const powerBarLevel = persistence.getData(stakeController.CurrentStake).x.x.p;
        this.setFillPercentage(powerBarLevel);
      }

      // Fill the power bar if not already filled (bought feature)
      if (data.enabled) {
        const duration = 0.25;
        this.pulsePowerBar(typeof data.time === 'number' ? duration : data.time);
        this.incrementPowerBar(100, typeof data.time === 'number' ? 1 : data.time);
        soundManager.play('powerBarZapFull');
      }

      let oldBar, newBar;
      if (data.enabled) {
        oldBar = this._blueParent;
        newBar = this._redParent;
        newBar.alpha = 0;
        newBar.visible = true;

        if (this._redParent.visible) {
          newBar.alpha = 1;
          this._skipBarSwitch = true;
        }
      } else {
        oldBar = this._redParent;
        newBar = this._blueParent;
        newBar.alpha = 0;
        newBar.visible = true;

        if (this._blueParent.visible) {
          newBar.alpha = 1;
          this._skipBarSwitch = true;
        }
      }

      if (data.enabled) {
        this._powerBarBlueExtra.visible = true;
        this._powerBarBlueExtra.gotoAndPlay(0);
      }

      if (!this._skipBarSwitch) {
        const DELAY = 1.0;
        const tween = gsap.to(oldBar, {
          alpha: 0,
          duration: 0.5,
          delay: DELAY,
          ease: 'linear',
          onComplete: () => {
            if (data.enabled) {
              this._powerBarBlueExtra.visible = false;
              this._powerBarBlueExtra.gotoAndStop(0);
            } else {
              this._powerBarRedExtra.visible = false;
              this._powerBarRedExtra.gotoAndStop(0);
            }
            oldBar.visible = false;
            oldBar.alpha = 1;
          },
        });
        if (!data.time) {
          tween.totalProgress(1);
        }
        const tween2 = gsap.to(newBar, {
          alpha: 1,
          duration: 0.5,
          delay: DELAY,
          ease: 'linear',
          onComplete: () => {
            newBar.alpha = 1;
          },
        });
        if (!data.time) {
          tween2.totalProgress(1);
        }
      } else {
        this._skipBarSwitch = false;
      }
    }

    pulsePowerBar(duration) {
      if (duration) {
        gsap
          .timeline()
          .to(this._powerBarContainer.scale, {
            x: 1.1,
            y: 1.1,
            duration,
            ease: 'linear',
            yoyo: true,
            repeat: 3,
          })
          .to(this._powerBarContainer.scale, {
            x: 1.1,
            y: 1.1,
            duration,
            delay: 1,
            ease: 'linear',
            yoyo: true,
            repeat: 3,
          });
      }
    }

    incrementPowerBar(increase, time) {
      const newLevel = this._currentPercent + increase;
      this.animatePowerBar(newLevel, time);
      if (time) {
        const halfTime = time / 2;
        gsap.to(this._powerBarContainer.scale, {
          x: 1.2,
          y: 1.2,
          duration: halfTime,
          ease: 'linear',
          onComplete: () => {
            gsap.to(this._powerBarContainer.scale, {
              x: 1.0,
              y: 1.0,
              duration: halfTime,
              ease: 'linear',
              onComplete: () => {
                this._powerBarContainer.scale.set(1);
              },
            });
          },
        });
      } else {
        this._powerBarContainer.scale.set(1);
      }
    }

    animatePowerBar(percent, time, callback) {
      if (percent < 0) {
        percent = 0;
      } else if (percent > 100) {
        percent = 100;
      }

      const displayPercent = Math.max(percent, this._minimumDisplayPercent);

      const newLength = (this._barMaxLength / 100) * displayPercent;
      gsap.killTweensOf(this._barMask);
      const tween = gsap.to(this._barMask, {
        x: newLength - this._barMaxLength,
        duration: typeof time === 'number' ? time : 0.1,
        ease: 'power2.inOut',
        onComplete: () => {
          this._barMask.x = newLength - this._barMaxLength;

          if (callback) {
            callback();
          }
        },
      });
      this._currentPercent = percent;
      if (!time || gdk.getServerParser()._restoringPreviousWager) {
        tween.progress(1);
      }
    }

    onLayoutChange() {}

    setFillPercentage(percent) {
      if (percent < 0) {
        percent = 0;
      } else if (percent > 100) {
        percent = 100;
      }

      // Apply minimum visual fill as requested
      const displayPercent = Math.max(percent, this._minimumDisplayPercent);

      const length = (this._barMaxLength / 100) * displayPercent;
      this._barMask.position.x = length - this._barMaxLength;
      this._currentPercent = percent;
    }

    onPersistenceStakeChanged(data) {
      this._currentPercent = data.data.x.x.p;
      this.animatePowerBar(this._currentPercent, 0.5);
    }

    isFull(powerAdded) {
      return this._currentPercent + powerAdded >= 100;
    }
  }

  let creator = function (json) {
    return new PowerBarDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('powerBarDisplay', creator, initialise, filesRequired);
})();
